// src/components/settings/ThirteenthMonthBasisCard.js
//
// PRD_ThirteenthMonthPay C4 — which pay components count as basic salary for
// 13th month pay. Modelled on ContributionBasisCard (same factor groups and
// labels) but a separate component: there is no Enable toggle (13th month is
// mandatory; this card only shapes the basis), no piece-rate radio (piece
// amounts are already inside basic pay), and it sits outside the Government
// Contributions section, so neither the in-flight-run lock nor the mid-month
// warning applies — this basis feeds no live run.

import React from "react";
import Icon from "../icons/Icon";
import { THIRTEENTH_MONTH_BASIS_FACTORS } from "../../constants/thirteenthMonthBasis";

const ThirteenthMonthBasisCard = ({ basis, canEdit, onToggleFactor }) => (
  <section className="settings-card" aria-label="13th Month Basis">
    <div className="settings-card-header">
      <div className="settings-card-header-left">
        <div className="settings-card-icon gold">
          <span role="img" aria-label="thirteenth month">
            <Icon name="calendar" size={20} />
          </span>
        </div>
        <div>
          <h2 className="settings-card-title">13th Month Basis</h2>
          <p className="settings-card-description">
            What counts as basic salary for 13th month pay
          </p>
        </div>
      </div>
    </div>

    <div className="settings-card-body">
      <div className="settings-input-hint">
        Basic pay is always included. The components below adjust it.
      </div>

      {[
        { sign: "add", title: "Added to the basis" },
        { sign: "subtract", title: "Subtracted from the basis" },
      ].map((group) => (
        <div key={group.sign} style={{ marginTop: 16 }}>
          <div className="form-label">{group.title}</div>
          {THIRTEENTH_MONTH_BASIS_FACTORS.filter(
            (f) => !f.alwaysOn && f.sign === group.sign
          ).map((f) => (
            <label
              key={f.key}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                marginTop: 10,
                cursor: canEdit ? "pointer" : "default",
                opacity: canEdit ? 1 : 0.6,
              }}
            >
              <input
                type="checkbox"
                aria-label={`13th month basis — ${f.label}`}
                checked={Boolean(basis?.factors?.[f.key])}
                disabled={!canEdit}
                onChange={() => onToggleFactor(f.key)}
              />
              <span style={{ fontWeight: 600 }}>{f.label}</span>
            </label>
          ))}
        </div>
      ))}
    </div>
  </section>
);

export default ThirteenthMonthBasisCard;
